import * as React from "react";
function SvgArrowRight(props) {
  return <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5 16h22m0 0l-8 8m8-8l-8-8" strokeWidth={1.5} stroke="currentColor" vectorEffect="non-scaling-stroke" strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
export default SvgArrowRight;